import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-radio-button',
    styleUrls: ['./radio-button.component.scss'],
    templateUrl: './radio-button.component.html',
    standalone: false
})
export class RadioButtonComponent implements OnInit {

  private static id = 1;

  @Input() public control: UntypedFormControl;
  @Input() public value: any;
  public group: UntypedFormGroup;
  public checked: boolean;
  public readonly uniqueId: number;

  constructor() { this.uniqueId = RadioButtonComponent.id++; }

  public ngOnInit() {
    this.setChecked(this.control.value);
    this.control.valueChanges.subscribe((value) => this.setChecked(value));
    this.group = new UntypedFormGroup({ control: this.control });
  }

  private setChecked(value: any): void {
    this.checked = this.value === value;
  }
}
